/*
*	打点
*/

function track (carId, callback, domain, n, salerphone) {
	if (!domain) {
		domain = '';
	}
	$.ajax({
		url: domain + '/json/track.json',
		type: 'GET',
		dataType: 'json',
		data: {	
			type: n,
			carId: carId,
			salerphone: salerphone,
			url: window.location.href
		}
	})
	.done(function(json) {
		// console.log("success");
		callback(null, json);
	})
	.fail(function() {
		// console.log("error");
		var err = 'get err in chunyan-demo/util/b.track';
		callback(err);
	})
	.always(function() {
		// console.log("complete");
	});
}

module.exports = {
	/**
	 * 预约打点
	 */
	subscribe: function (carId, callback, domain) {
		track(carId, callback, domain, 1);
	},
	/**
	 * @Deprecated
	 * 收藏打点
	 * 已弃用
	 */
	collect: function (carId, callback, domain) {
		track(carId, callback, domain, 2);
	},
	/**
	 * @Deprecated
	 * 拨打卖家电话打点
	 * 已弃用
	 */
	callphone: function (carId, callback, domain) {
		track(carId, callback, domain, 3);
	},
	/**
	 * 新版拨打电话打点，如果为app分享取分享手机号
	 */
	callphoneWithSalerphone: function (carId, salerphone, callback, domain) {	//
		track(carId, callback, domain, 3, salerphone);
	},
	/**
	 * app 内分享打点
	 */
	share: function (callback) {
		track('', callback);
	}
};


//////////////////
// WEBPACK FOOTER
// ./~/@souche-f2e/chunyan-util/qiwa-track/b.track.js
// module id = 282
// module chunks = 4